import styled from 'styled-components'

const ToggleWrapper = styled.div`
  padding-right: 24px;
  position: relative;
`;

const ToogleGroup = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: auto;
  margin-left: 24px;
`

const ToggleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  @media(max-width: 767px) {
    margin-left: auto;
    flex-direction: column;
    justify-content: flex-start;
    &:not(:last-child) {
      margin-right: 12px;
    }
  }
`

const ToggleLabel = styled.label`
  position: absolute;
  top: 3px;
  left: 7px;
  width: 24px;
  border-radius: 15px;
  background: #919191;
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 9.6px;
    height: 9.6px;
    margin: 3px;
    background: #FFFFFF;
    transition: 0.2s;
  }
`;

const ToggleText = styled.span`
  font-size: 12px;
  white-space: nowrap;
`

const Toggle = styled.input<ToggleProps>`
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 24px;
  height: 14px;
  &:checked + ${ToggleLabel} {
    background: ${({ color }) => color};
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 9.6px;
      height: 9.6px;
      margin-left: 12px;
      transition: 0.2s;
    }
  }
`;

export {
  Toggle,
  ToogleGroup,
  ToggleItem,
  ToggleLabel,
  ToggleText,
  ToggleWrapper
}

export interface ToggleProps {
  color: string
}